export default __webpack_public_path__ + "static/media/coronavirus.2769a27f.svg";